import React from "react";
import { Box, Typography, Link } from "@mui/material";
import Markdown from "markdown-to-jsx";
import ImageViewer from "../imageViewer";

function MarkdownList(props) {
  return (
    <Box
      component="ul"
      sx={{
        paddingLeft: "20px",
      }}
      {...props}
    />
  );
}

function MarkdownListItem(props) {
  return <Box component="li" sx={{ mt: 1, typography: "body1" }} {...props} />;
}

function MarkdownImage(props) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Box
        component="img"
        onClick={() => setOpen(true)}
        sx={{
          display: "flex",
          objectFit: "contain",
          height: "100%",
          maxWidth: "min(85vw, 800px)",
          maxHeight: "max(85vh, 500px)",
          ml: "auto",
          mr: "auto",
          mt: 5,
          mb: 5,
          borderRadius: "7px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
        {...props}
      />
      {open && (
        <ImageViewer src={props.src} handleClose={() => setOpen(false)} />
      )}
    </>
  );
}

function MarkdownLink(props) {
  return <Link target="_blank" rel="noreferrer" {...props} />;
}

const options = {
  overrides: {
    h1: {
      component: Typography,
      props: {
        gutterBottom: true,
        variant: "h4",
        component: "h1",
      },
    },
    h2: {
      component: Typography,
      props: { gutterBottom: true, variant: "h5", component: "h2" },
    },
    h3: {
      component: Typography,
      props: { gutterBottom: true, variant: "subtitle1" },
    },
    h4: {
      component: Typography,
      props: {
        gutterBottom: true,
        variant: "caption",
        paragraph: true,
      },
    },
    p: {
      component: Typography,
      props: { paragraph: true },
    },
    a: { component: MarkdownLink },
    ul: { component: MarkdownList },
    i: {
      component: MarkdownListItem,
    },
    img: {
      component: MarkdownImage,
    },
  },
};

let MdViewer = ({ children }) => {
  return <Markdown options={options}>{children}</Markdown>;
};

MdViewer = React.memo(MdViewer);

export default MdViewer;
